import { Reveal } from "./Reveal";

const ICONS = {
  building: (
    <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden="true" className="h-7 w-7">
      <path d="M6 28V10l8-5v23M14 28V14l12 6v8M2 28h28" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 13h2M9 17h2M9 21h2M18 19h2M18 23h2M23 21h2M23 25h2" strokeLinecap="round" />
    </svg>
  ),
  mind: (
    <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden="true" className="h-7 w-7">
      <path d="M16 28s-9-5.6-9-12a5.2 5.2 0 0 1 9-3.6A5.2 5.2 0 0 1 25 16c0 6.4-9 12-9 12Z" strokeLinejoin="round" />
      <path d="M16 12v7M12.5 15.5h7" strokeLinecap="round" />
    </svg>
  ),
  community: (
    <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden="true" className="h-7 w-7">
      <circle cx="11" cy="11" r="4" />
      <circle cx="22" cy="13" r="3" />
      <path d="M3 27c0-5 3.6-8 8-8s8 3 8 8M19 21.5c3.4.4 6 2.6 6 5.5" strokeLinecap="round" />
    </svg>
  ),
  book: (
    <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden="true" className="h-7 w-7">
      <path d="M16 8c-2.5-2-6-2.5-11-2v20c5-.5 8.5 0 11 2 2.5-2 6-2.5 11-2V6c-5-.5-8.5 0-11 2Z" strokeLinejoin="round" />
      <path d="M16 8v20" strokeLinecap="round" />
    </svg>
  ),
};

const CAPABILITIES = [
  {
    id: "business-executive",
    sheet: "VHE-03A",
    icon: ICONS.building,
    title: "Business & Executive Infrastructure",
    text: "Business solutions, executive office share, rural entrepreneurship and economic innovation support, and strategic frameworks for founders, leaders, and emerging ventures.",
  },
  {
    id: "behavioral-health",
    sheet: "VHE-03B",
    icon: ICONS.mind,
    title: "Behavioral Health & Organizational Consulting",
    text: "Mental, behavioral, and organizational consulting rooted in trauma-informed insight, leadership support, workforce development, and strategic systems consultation.",
  },
  {
    id: "youth-community",
    sheet: "VHE-03C",
    icon: ICONS.community,
    title: "Youth & Community Impact",
    text: "Independent-living innovations centered on life-skills development, commitment to life-long natural support, mutual mentorship, and community-centered transitional support.",
  },
  {
    id: "publishing-media",
    sheet: "VHE-03D",
    icon: ICONS.book,
    title: "Publishing, Education & Transformative Media",
    text: "Thought leadership, literature, media, branding, educational resources/curriculums designed to inspire transformation, advance knowledge, and equip the community and future generations.",
  },
];

const Capabilities = () => (
  <section id="capabilities" data-testid="capabilities-section" aria-labelledby="capabilities-heading" className="parchment-noise relative overflow-hidden border-t border-parchborder py-24 sm:py-32">
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="mb-4 flex items-center justify-center gap-5 font-mono text-[10px] uppercase tracking-[0.4em] text-royal sm:text-[11px]" data-testid="capabilities-eyebrow">
          <span className="inline-block h-px w-12 bg-royal/50" />
          Our Capabilities
          <span className="inline-block h-px w-12 bg-royal/50" />
        </p>
        <h2 id="capabilities-heading" className="font-serif text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl">
          Strategic Solutions for a <em className="ember-text">Brighter Tomorrow</em>
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
        {CAPABILITIES.map((cap, i) => (
          <Reveal key={cap.id} delay={0.1 * i}>
            <article
              data-testid={`capability-card-${cap.id}`}
              className="trace-card group flex h-full flex-col border border-parchborder bg-white/70 p-7 shadow-[0_10px_30px_-18px_rgba(5,11,24,0.25)] backdrop-blur-sm"
            >
              <div className="mb-6 flex items-center justify-between">
                <span className="flex h-14 w-14 items-center justify-center rounded-full border border-gold/40 bg-navy text-gold transition-colors duration-500 group-hover:bg-ember group-hover:text-parchment">
                  {cap.icon}
                </span>
                <span className="font-mono text-[9px] uppercase tracking-[0.3em] text-royal/60">{cap.sheet}</span>
              </div>
              <h3 className="font-serif text-lg font-semibold leading-snug text-royal sm:text-xl">{cap.title}</h3>
              <span className="my-4 inline-block h-px w-10 bg-gold" aria-hidden="true" />
              <p className="text-sm leading-relaxed text-ink2">{cap.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Capabilities;
